module.exports = __webpack_public_path__ + "img/017.37a885f6.png";